import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { ApproveMilestoneDto } from '../../types/vesting-tasks.types';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

export const useApproveTargetBasedVestingTasks = ({ companyId }: { companyId: string }) => {
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.GET_NOTIFICATIONS,
    QueryKey.GET_APPROVE_TARGET_BASED_VESTING_TASKS,
    QueryKey.GET_APPROVE_TARGET_BASED_UNFINISHED_VESTING_TASKS,
    QueryKey.GET_SNAPSHOT,
    QueryKey.GET_VESTING_TASKS,
    QueryKey.GET_VESTING_GRAPH,
    QueryKey.GET_POOLS,
    QueryKey.GET_SHARE_PLANS,
    QueryKey.SHARE_PLAN_STAKEHOLDERS,
    QueryKey.GET_STAKEHOLDER_OWNERSHIP_SUMMARY,
    QueryKey.GET_STAKEHOLDER_CONSOLIDATED_POSITION,
    QueryKey.GET_STAKEHOLDERS_WITH_GRANTS,
    QueryKey.GET_POOLS_BY_STAKEHOLDER,
  );

  const { mutate: approve, isPending } = useAppMutation(
    [QueryKey.APPROVE_TARGET_BASED_MILESTONE, companyId],
    {
      mutationFn: (body: ApproveMilestoneDto[]) =>
        ApiService.post(
          {
            endpoint: BackendRoute.COMPANIES,
            routePath: [companyId, 'share-plans', 'approve-target-based'],
          },
          { body },
        ),

      onSuccess: () => {
        invalidateQuery();
      },
    },
  );

  return {
    approve,
    isPending,
    invalidateQuery,
  };
};
